import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import 'dayjs/locale/ru';
import 'dayjs/locale/en';

dayjs.extend(utc);

export function getTimeDates(timeDate: string) {
  const currentLanguage = localStorage.getItem('i18nextLng') || 'ru';
  dayjs.locale(currentLanguage);

  const formattedDate = dayjs.utc(timeDate).format('DD MMMM YYYY г. HH:mm');
  return formattedDate;
}
